import './crash-history.scss';

import NiceModal from '@ebay/nice-modal-react';
import { memo } from 'react';

import { useAppSelector } from '@/app/store/hooks';
import { selectJettonHistory } from '@/entities/jetton';
import { MODALS } from '@/shared/config/modals';
import { getMultiplierTierClass } from '@/shared/lib/game/getMultiplierTierClass';

const showRoundDetail = (roundId: string) =>
  NiceModal.show(MODALS.JETTON_ROUND_DETAIL, { roundId });

const CrashHistory = memo(() => {
  const history = useAppSelector(selectJettonHistory);

  if (history.length === 0) return null;

  return (
    <div className="jch">
      {history.map((entry) => {
        const tierClass = getMultiplierTierClass(entry.crashMultiplier);
        return (
          <div
            key={entry.id}
            className={`jch__chip ${tierClass}`}
            onClick={() => showRoundDetail(entry.id)}>
            {entry.crashMultiplier.toFixed(2)}x
          </div>
        );
      })}
    </div>
  );
});

export { CrashHistory };
